import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
@Injectable({
    providedIn: 'root'
})
export class CheckIntro implements CanLoad {
    constructor(
        private router: Router,
        private auth: AuthService) { }

    canLoad() {
        return this.auth.storage.get('ion_did_intro').then(res => {
            if (res && this.auth.user) {
                this.router.navigate(['/app', 'tabs', 'schedule']);
                return false;
            } else {
                return true;
            }
        });
    }
}
